module.exports = __webpack_public_path__ + "static/media/gold.a53acb08.png";